var map = {
	"./layouts/Admin": 24810,
	"./layouts/ThreeDTourEmbed": 99710,
	"./layouts/Truva": 67604,
	"./layouts/VideoEmbed": 49820,
	"components/layouts/Admin": 24810,
	"components/layouts/ThreeDTourEmbed": 99710,
	"components/layouts/Truva": 67604,
	"components/layouts/VideoEmbed": 49820
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81033;